export class UnauthorizedError extends Error {
  readonly status: 401 | 403;

  constructor(status: 401 | 403, message = 'Unauthorized') {
    super(message);
    this.name = 'UnauthorizedError';
    this.status = status;
  }
}
